import { inject, Pipe, PipeTransform } from '@angular/core';
import { VirtualClinicService } from '../core';
import { Observable, startWith } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'virtualClinic',
  standalone: true,
})
export class VirtualClinicPipe implements PipeTransform {
  private readonly _virtualClinicService = inject(VirtualClinicService);

  transform(value: string): Observable<string> {
    return this._virtualClinicService.findById(value).pipe(
      startWith({ name: 'wird geladen..' }),
      map((virtualClinic) => virtualClinic.name),
    );
  }
}
